import { mergeStyleSets } from '@fluentui/react';

export const caseDetailStyles = mergeStyleSets({
  container: {
    background: '#ffffff',
    marginTop: 16,
    borderTop: '1px solid #e5e7eb',
  },
  infoCard: {
    background: '#ffffff',
    borderBottom: '1px solid #e5e7eb',
    padding: '16px 28px',
    margin: '0',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto 1fr auto',
    gap: '10px 24px',
    alignItems: 'center',
    selectors: {
      '@media (max-width: 1023px)': {
        gridTemplateColumns: 'auto 1fr auto 1fr',
        padding: '16px 20px',
      },
      '@media (max-width: 768px)': {
        gridTemplateColumns: 'auto 1fr',
        gap: '8px 12px',
        padding: '12px 16px',
      },
    },
  },
  infoLabel: {
    fontSize: 13,
    color: '#111827',
    fontWeight: 600 as const,
  },
  infoValue: {
    fontSize: 14,
    color: '#6b7280',
    fontWeight: 500 as const,
  },
  statusBadge: {
    display: 'inline-block',
    padding: '6px 16px',
    borderRadius: 20,
    border: '1px solid #333',
    color: '#333',
    fontSize: 13,
    fontWeight: 600 as const,
    gridRow: '1 / 4',
    gridColumn: '5',
    alignSelf: 'center',
    selectors: {
      '@media (max-width: 1023px)': {
        gridRow: 'auto',
        gridColumn: 'span 4',
        justifySelf: 'start',
      },
      '@media (max-width: 768px)': {
        gridColumn: 'span 2',
      },
    },
  },
  stepperContainer: {
    padding: '28px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    selectors: {
      '@media (max-width: 768px)': {
        padding: '16px 12px',
        overflowX: 'auto',
      },
    },
  },
  stepperLine: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 800,
    position: 'relative' as const,
  },
  stepItem: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    flex: 1,
    position: 'relative' as const,
  },
  stepCircle: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    background: '#0078d4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    fontSize: 16,
    fontWeight: 700 as const,
    zIndex: 2,
    border: '3px solid #0078d4',
  },
  stepCircleActive: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    background: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#0078d4',
    fontSize: 14,
    fontWeight: 700 as const,
    zIndex: 2,
    border: '3px solid #0078d4',
  },
  stepCircleInactive: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    background: '#e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6b7280',
    fontSize: 14,
    fontWeight: 600 as const,
    zIndex: 2,
    border: '3px solid #e5e7eb',
  },
  stepCircleBlocked: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    background: '#d13438',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    fontSize: 16,
    fontWeight: 700 as const,
    zIndex: 2,
    border: '3px solid #d13438',
  },
  stepLabel: {
    fontSize: 11,
    color: '#374151',
    textAlign: 'center' as const,
    marginTop: 8,
    maxWidth: 90,
    lineHeight: '1.3',
    fontWeight: 500 as const,
  },
  stepConnector: {
    position: 'absolute' as const,
    top: 20,
    left: '50%',
    right: '-50%',
    height: 3,
    background: '#0078d4',
    zIndex: 1,
  },
  stepConnectorInactive: {
    position: 'absolute' as const,
    top: 20,
    left: '50%',
    right: '-50%',
    height: 3,
    background: '#e5e7eb',
    zIndex: 1,
  },
  tabsContainer: {
    borderBottom: '2px solid #e5e7eb',
    padding: '0 24px',
    display: 'flex',
    gap: 0,
    selectors: {
      '@media (max-width: 768px)': {
        padding: '0 12px',
        overflowX: 'auto',
      },
    },
  },
  tab: {
    padding: '12px 20px',
    fontSize: 14,
    fontWeight: 500 as const,
    color: '#6b7280',
    cursor: 'pointer',
    borderBottom: '3px solid transparent',
    background: 'none',
    border: 'none',
    selectors: {
      ':hover': { color: '#0078d4' },
    },
  },
  tabActive: {
    padding: '12px 20px',
    fontSize: 14,
    fontWeight: 600 as const,
    color: '#0078d4',
    cursor: 'pointer',
    borderBottom: '3px solid #0078d4',
    background: 'none',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
  },
  tabDisabled: {
    padding: '12px 20px',
    fontSize: 14,
    fontWeight: 500 as const,
    color: '#c8c6c4',
    cursor: 'not-allowed',
    borderBottom: '3px solid transparent',
    background: 'none',
    border: 'none',
    opacity: 0.6,
  },
  tabContent: {
    padding: '24px',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    selectors: {
      '@media (max-width: 768px)': {
        gridTemplateColumns: '1fr',
        gap: '16px',
      },
    },
  },
  formLabel: {
    fontSize: 13,
    color: '#111827',
    fontWeight: 600 as const,
    marginBottom: 6,
  },
  formValue: {
    background: 'transparent',
    border: 'none',
    padding: '6px 0',
    fontSize: 14,
    color: '#323130',
    height: 32,
    display: 'flex',
    alignItems: 'center',
  },
  editableNote: {
    fontSize: 12,
    color: '#6b7280',
    fontStyle: 'italic' as const,
    marginTop: 12,
  },
  footerActions: {
    display: 'flex',
    gap: 12,
    marginTop: 20,
  },
  saveButton: {
    background: '#0078d4',
    border: 'none',
    borderRadius: 4,
    color: '#ffffff',
    fontWeight: 600 as const,
    padding: '10px 24px',
    cursor: 'pointer',
    fontSize: 14,
    selectors: {
      '&[aria-disabled="true"]': {
        cursor: 'not-allowed',
        opacity: 0.5,
      },
    },
  },
  cancelButton: {
    background: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: 6,
    color: '#374151',
    fontWeight: 500 as const,
    padding: '10px 24px',
    cursor: 'pointer',
    fontSize: 14,
  },
  pauseButton: {
    background: 'linear-gradient(135deg, #d97706, #b45309)',
    border: 'none',
    borderRadius: 20,
    color: '#ffffff',
    fontWeight: 600 as const,
    padding: '10px 24px',
    cursor: 'pointer',
    fontSize: 14,
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 'auto',
    selectors: {
      ':hover': { background: 'linear-gradient(135deg, #b45309, #92400e)' },
    },
  },
  resumeButton: {
    background: 'linear-gradient(135deg, #059669, #047857)',
    border: 'none',
    borderRadius: 20,
    color: '#ffffff',
    fontWeight: 600 as const,
    padding: '10px 24px',
    cursor: 'pointer',
    fontSize: 14,
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 'auto',
    selectors: {
      ':hover': { background: 'linear-gradient(135deg, #047857, #065f46)' },
    },
  },
  cancelCaseButton: {
    background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
    border: 'none',
    borderRadius: 20,
    color: '#ffffff',
    fontWeight: 600 as const,
    padding: '10px 24px',
    cursor: 'pointer',
    fontSize: 14,
    display: 'inline-flex',
    alignItems: 'center',
    selectors: {
      ':hover': { background: 'linear-gradient(135deg, #b91c1c, #991b1b)' },
    },
  },
  currentStepTitle: {
    fontSize: 16,
    fontWeight: 700 as const,
    color: '#111827',
    marginBottom: 4,
  },
  currentStepSubtitle: {
    fontSize: 13,
    color: '#6b7280',
    marginBottom: 16,
  },
  workflowCard: {
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    padding: '20px',
    marginBottom: 16,
  },
  workflowCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  workflowCardTitle: {
    fontSize: 15,
    fontWeight: 600 as const,
    marginBottom: 12,
    display: 'flex',
    alignItems: 'center',
  },
  sentBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: 16,
    background: '#d1fae5',
    color: '#065f46',
    fontSize: 12,
    fontWeight: 600 as const,
  },
  pendingBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: 16,
    background: '#fef3c7',
    color: '#92400e',
    fontSize: 12,
    fontWeight: 600 as const,
  },
  skippedBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: 16,
    background: '#e5e7eb',
    color: '#4b5563',
    fontSize: 12,
    fontWeight: 600 as const,
  },
  badgeIcon: {
    marginRight: 4,
    fontSize: 12,
  },
  workflowField: {
    display: 'flex',
    gap: 24,
    marginBottom: 8,
  },
  workflowFieldLabel: {
    fontSize: 13,
    color: '#6b7280',
    fontStyle: 'italic' as const,
    minWidth: 140,
  },
  workflowFieldValue: {
    fontSize: 14,
    color: '#111827',
    fontWeight: 600 as const,
  },
  bypassBanner: {
    display: 'flex',
    alignItems: 'center',
    background: '#f3f2f1',
    border: '1px solid #edebe9',
    borderRadius: 4,
    padding: '10px 16px',
    marginTop: 16,
    fontSize: 13,
    color: '#323130',
    fontWeight: 600 as const,
  },
  workflowBlockedBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    background: '#fed9cc',
    color: '#201f1e',
    padding: '10px 12px',
    marginBottom: 16,
    fontSize: 13,
    lineHeight: 20,
  },
  warningBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 8,
    padding: '2px 8px',
    borderRadius: 4,
    background: '#fef3c7',
    border: '1px solid #f59e0b',
    color: '#92400e',
    fontSize: 11,
    fontWeight: 600 as const,
  },
  immigrationBanner: {
    background: '#fef9c3',
    border: '1px solid #fde68a',
    borderRadius: 6,
    padding: '10px 16px',
    fontSize: 14,
    color: '#78350f',
    lineHeight: '1.5',
  },
  sevenDayBanner: {
    background: '#fff7ed',
    border: '1px solid #fed7aa',
    borderRadius: 6,
    padding: '10px 16px',
    fontSize: 14,
    color: '#9a3412',
    lineHeight: '1.5',
  },
  dataTable: {
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    overflow: 'hidden',
  },
  dataRow: {
    display: 'grid',
    gridTemplateColumns: '160px 1fr 160px 1fr',
    borderBottom: '1px solid #f3f4f6',
    selectors: {
      ':last-child': {
        borderBottom: 'none',
      },
    },
  },
  dataLabel: {
    padding: '14px 16px',
    fontSize: 13,
    color: '#92400e',
    fontWeight: 500 as const,
    background: '#fffbeb',
  },
  dataValue: {
    padding: '14px 16px',
    fontSize: 14,
    color: '#111827',
    fontWeight: 600 as const,
  },
  missingFieldBanner: {
    background: '#ffe4e6',
    border: '1px solid #fecdd3',
    borderRadius: 6,
    padding: '10px 16px',
    fontSize: 14,
    color: '#9f1239',
    lineHeight: '1.5',
  },
  dataRowMissing: {
    display: 'grid',
    gridTemplateColumns: '160px 1fr 160px 1fr',
    borderBottom: '1px solid #f3f4f6',
    selectors: {
      ':last-child': {
        borderBottom: 'none',
      },
    },
  },
  blockingBanner: {
    background: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: 8,
    padding: '16px 20px',
    fontSize: 14,
    color: '#991b1b',
    lineHeight: '1.5',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 8,
  },
  blockingTitle: {
    fontWeight: 700 as const,
    fontSize: 15,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  blockingActions: {
    display: 'flex',
    gap: 10,
    marginTop: 8,
  },
  warningBanner: {
    background: '#fffbeb',
    border: '1px solid #fde68a',
    borderRadius: 8,
    padding: '14px 20px',
    fontSize: 14,
    color: '#92400e',
    lineHeight: '1.5',
  },
  warningTitle: {
    fontWeight: 700 as const,
    fontSize: 14,
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  warningList: {
    margin: 0,
    paddingLeft: 20,
    fontSize: 13,
    lineHeight: '1.8',
  },
  overrideSection: {
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: 8,
    padding: '16px 20px',
    marginTop: 8,
  },
  overrideTitle: {
    fontSize: 14,
    fontWeight: 600 as const,
    marginBottom: 12,
    color: '#334155',
  },
  overrideField: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 10,
  },
  overrideLabel: {
    fontSize: 13,
    fontWeight: 500 as const,
    color: '#475569',
    minWidth: 140,
  },
  overrideInput: {
    flex: 1,
    padding: '8px 12px',
    border: '1px solid #cbd5e1',
    borderRadius: 6,
    fontSize: 13,
    outline: 'none',
  },
  retryButton: {
    background: '#ffffff',
    border: '1px solid #dc2626',
    borderRadius: 6,
    color: '#dc2626',
    fontWeight: 600 as const,
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: 13,
  },
  overrideButton: {
    background: '#ffffff',
    border: '1px solid #0078d4',
    borderRadius: 6,
    color: '#0078d4',
    fontWeight: 600 as const,
    padding: '8px 16px',
    cursor: 'pointer',
    fontSize: 13,
  },
  submitOverrideButton: {
    background: '#0078d4',
    border: 'none',
    borderRadius: 6,
    color: '#ffffff',
    fontWeight: 600 as const,
    padding: '8px 20px',
    cursor: 'pointer',
    fontSize: 13,
    marginTop: 10,
  },
  hrcGateAction: {
    marginTop: 16,
    paddingTop: 16,
    borderTop: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'flex-start',
    gap: 8,
  },
  proceedButton: {
    background: '#0b6a0b',
    border: 'none',
    borderRadius: 4,
    color: '#ffffff',
    fontWeight: 600 as const,
    padding: '10px 24px',
    cursor: 'pointer',
    fontSize: 14,
    selectors: {
      '&:disabled': { background: '#9ca3af', cursor: 'not-allowed' },
    },
  },
});
